/**
 * @constant
 */

export const size = {
  sm: 576,
  md: 768,
  lg: 1024,
  hd: 1280,
  midHd: 1600,
  fullHd: 1920,
};

export const device = {
  phablet: `(min-width: ${size.md}px)`,
  desktop: `(min-width: ${size.hd}px)`,
  mediumDesktop: `(min-width: ${size.midHd}px)`,
  largeDesktop: `(min-width: ${size.fullHd}px)`,
  shortViewport: `(max-height: 620px)`,
};

/**
 * @param {{
 * sm: string,
 * md: string,
 * lg: string,
 * xl: string
 * }} size
 */

export default (Object.keys(size) as Array<keyof typeof size>).reduce(
  (acc, key) => {
    acc[key] = (style: String) => ` (min-width: ${size[key]}px) { ${style} }`;
    return acc;
  },
  {} as { [index: string]: Function },
);
